import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { useAuth } from "../store/auth";

function fmtAR(n: number): string {
  return "$" + n.toLocaleString("es-AR", { maximumFractionDigits: 0 });
}

function formatTime(d: Date): string {
  return d.toLocaleTimeString("es-AR", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

function turnoActual(d: Date): string {
  const h = d.getHours();
  if (h < 13) return "Turno mañana";
  if (h < 20) return "Turno tarde";
  return "Turno noche";
}

export default function BrandStrip({ cajaNum = 3 }: { cajaNum?: number }) {
  const user = useAuth((s) => s.user);
  const [now, setNow] = useState<Date>(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30_000);
    return () => clearInterval(id);
  }, []);

  const { data: resumen } = useQuery({
    queryKey: ["reporte-diario"],
    queryFn: async () => {
      const hoy = new Date().toISOString().slice(0, 10);
      const { data } = await api.get<{
        cantidad_ventas: number;
        total: number;
      }>("/api/reports/ventas/diario", { params: { dia: hoy } });
      return data;
    },
    refetchInterval: 30_000,
    retry: false,
  });

  const ventasHoy = resumen?.total ?? 0;
  const tickets = resumen?.cantidad_ventas ?? 0;
  const userLabel = user?.nombre ?? "JL";

  return (
    <div
      className="relative overflow-hidden mx-4 mt-3 rounded-2xl text-white flex items-center gap-3.5 px-4 py-3"
      style={{
        background: "var(--brand-red)",
        boxShadow: "0 6px 18px -8px rgba(230,53,61,0.5)",
      }}
    >
      {/* decoración: círculos brand-green / cream sobre el rojo */}
      <span
        className="absolute -top-2 right-1 w-20 h-20 rounded-full pointer-events-none"
        style={{ background: "var(--brand-green)", opacity: 0.18 }}
      />
      <span
        className="absolute -top-5 right-12 w-14 h-14 rounded-full pointer-events-none"
        style={{ background: "var(--brand-cream)", opacity: 0.14 }}
      />

      <div className="w-10 h-10 flex-shrink-0 relative">
        <img
          src="/logo.png"
          alt="Maxi Kiosko JL"
          className="w-full h-full object-contain drop-shadow"
        />
      </div>

      <div className="flex-1 min-w-0 relative">
        <div
          className="text-2xl font-bold leading-none"
          style={{ fontFamily: "var(--font-display)" }}
        >
          Maxi Kiosko JL
        </div>
        <div className="text-[12px] font-semibold opacity-90 mt-1 truncate">
          Caja #{cajaNum} · {turnoActual(now)} · {userLabel}
        </div>
      </div>

      <div className="flex items-center gap-3.5 relative">
        <div className="text-right">
          <div className="text-[10px] font-bold tracking-wider opacity-80">
            VENTAS HOY
          </div>
          <div className="text-lg font-extrabold tabular-nums tracking-tight">
            {fmtAR(ventasHoy)}
          </div>
        </div>
        <div className="w-px h-7 bg-white/25" />
        <div className="text-right">
          <div className="text-[10px] font-bold tracking-wider opacity-80">
            TICKETS
          </div>
          <div className="text-lg font-extrabold tabular-nums tracking-tight">
            {tickets}
          </div>
        </div>
        <div className="w-px h-7 bg-white/25" />
        <div className="text-[13px] font-bold tabular-nums">
          {formatTime(now)}
        </div>
      </div>
    </div>
  );
}
